import { Pipe, PipeTransform } from '@angular/core';

import { TaxRegimeCode } from '@enums/tax-regime-code.enum';
import { TaxRegime } from '@models/tax-regime';

@Pipe({
  name: 'condensedTaxRegimeLabel',
  standalone: true
})
export class CondensedTaxRegimeLabelPipe implements PipeTransform {
  transform(taxRegimeCode: TaxRegimeCode, taxRegimes: TaxRegime[]): string {
    return taxRegimes?.length
      ? taxRegimes.find((taxRegime: TaxRegime) => taxRegime.code === taxRegimeCode)?.condensedLabel || ''
      : '';
  }
}
